import { render } from "./StatisticsPage.vue?vue&type=template&id=1d2c0d7c&ts=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=ts"
export * from "./StatisticsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__